/*
 * Generated from Times-Bold.afm. Do not edit directly.
 * The source AFM metrics were converted to JavaScript; this is a modification.
 * Copyright (c) 1985, 1987, 1989, 1990, 1993, 1997 Adobe Systems Incorporated.  All Rights Reserved.Times is a trademark of Linotype-Hell AG and/or its subsidiaries.
 *
 * This file and the 14 PostScript(R) AFM files it accompanies may be used, copied, and distributed for any purpose and without charge, with or without modification, provided that all copyright notices are retained; that the AFM files are not distributed without this file; that all modifications to this file or any of the AFM files are prominently noted in the modified file(s); and that this paragraph is not modified. Adobe Systems has no responsibility or obligation to support the use of the AFM files.
 */
import glyphNames from './standardGlyphNames.js';
export default {
  name: 'Times-Bold',
  bbox: [-168, -218, 1000, 935],
  ascender: 683,
  descender: -217,
  xHeight: 461,
  capHeight: 676,
  glyphNames,
  glyphWidths: [
    250, 333, 555, 500, 500, 1000, 833, 278, 333, 333, 500, 570, 250, 333, 250,
    278, 500, 500, 500, 500, 500, 500, 500, 500, 500, 500, 333, 333, 570, 570,
    570, 500, 930, 722, 667, 722, 722, 667, 611, 778, 778, 389, 500, 778, 667,
    944, 722, 778, 611, 778, 722, 556, 667, 722, 722, 1000, 722, 722, 667, 333,
    278, 333, 581, 500, 333, 500, 556, 444, 556, 444, 333, 500, 556, 278, 333,
    556, 278, 833, 556, 500, 556, 556, 444, 389, 333, 556, 500, 722, 500, 500,
    444, 394, 220, 394, 520, 500, 333, 500, 500, 1000, 500, 500, 333, 1000, 556,
    333, 1000, 667, 333, 333, 500, 500, 350, 500, 1000, 333, 1000, 389, 333,
    722, 444, 500, 333, 500, 500, 500, 500, 220, 500, 333, 747, 300, 500, 570,
    747, 333, 400, 570, 300, 300, 333, 556, 540, 250, 333, 300, 330, 500, 750,
    750, 750, 500, 722, 722, 722, 722, 722, 722, 1000, 722, 667, 667, 667, 667,
    389, 389, 389, 389, 722, 722, 778, 778, 778, 778, 778, 570, 778, 722, 722,
    722, 722, 722, 611, 556, 500, 500, 500, 500, 500, 500, 722, 444, 444, 444,
    444, 444, 278, 278, 278, 278, 500, 556, 500, 500, 500, 500, 500, 570, 500,
    556, 556, 556, 556, 500, 556,
  ],
  kernPairs: [
    -145,
    [7149, 4475, 21110, 215, 215, 215, 215, 215],
    -135,
    [11643, 119, 1, 1, 1, 1, 1],
    -130,
    [7150, 25585, 215, 215, 215, 215, 215],
    -129,
    [11622],
    -120,
    [11858, 119, 1, 1, 1, 1, 1],
    -111,
    [12324, 10, 114, 1, 8, 1, 1, 1, 1, 2, 26521, 10, 114, 1, 8, 1, 1, 1, 1, 2],
    -110,
    [8184, 1385, 765, 1954, 119, 1, 1, 1, 1, 1, 26536, 119, 1, 1, 1, 1, 1],
    -100,
    [
      7152, 29, 95, 4403, 10, 113, 1, 1, 1, 7, 1, 1, 1, 1, 2, 5826, 15093, 29,
      95, 91, 29, 95, 91, 29, 95, 91, 29, 95, 91, 29, 95, 91, 29, 95,
    ],
    -95,
    [7147, 25585, 215, 215, 215, 215, 215],
    -92,
    [
      8182, 1330, 2, 1, 2, 124, 691, 861, 52, 4, 10, 6, 100, 4, 4, 1, 8, 1, 1,
      1, 1, 2, 1, 1, 1, 1, 244, 1, 38, 20, 99, 1, 1, 1, 1, 1, 20, 1, 1, 1, 15,
      2, 428, 1, 1, 12, 1, 58, 124, 1, 1, 1, 5175, 21285, 1, 1, 12, 1, 58, 124,
      1, 1, 1,
    ],
    -90,
    [
      7182, 1021, 119, 1, 1, 1, 1, 1, 2867, 19, 119, 1, 1, 1, 1, 1, 21430, 215,
      215, 215, 215, 215,
    ],
    -85,
    [12320, 119, 1, 1, 1, 1, 1, 26536, 119, 1, 1, 1, 1, 1],
    -75,
    [11904, 123, 1, 1, 1, 1, 2],
    -74,
    [
      7184, 20, 12, 92, 3045, 119, 1, 1, 1, 1, 1, 715, 14, 1, 55, 5, 356, 11812,
      9334, 20, 12, 92, 91, 20, 12, 92, 91, 20, 12, 92, 91, 20, 12, 92, 91, 20,
      12, 92, 91, 20, 12, 92,
    ],
    -71,
    [12447, 3, 26657, 3],
    -70,
    [18504, 215, 430, 6880, 19780],
    -65,
    [11890, 4, 115, 1, 1, 1, 1, 1, 3, 1, 1, 1],
    -63,
    [23328, 216],
    -60,
    [
      11428, 119, 1, 1, 1, 1, 1, 362, 32, 92, 26050, 119, 1, 1, 1, 1, 1, 91,
      119, 1, 1, 1, 1, 1, 91, 119, 1, 1, 1, 1, 1, 91, 119, 1, 1, 1, 1, 1,
    ],
    -55,
    [
      33, 24, 95, 1, 1, 1, 1, 1, 24, 2508, 430, 2, 4009, 4, 120, 2295, 32, 92,
      1131, 1047, 1, 6650, 215, 430, 6880, 6688, 4, 120, 91, 4, 120, 91, 4, 120,
      91, 4, 120, 91, 4, 120, 91, 4, 120, 11893,
    ],
    -52,
    [11364, 2, 1, 1, 4, 3],
    -50,
    [
      7148, 32, 92, 1, 1, 1, 29, 1, 1, 1, 2852, 1, 2, 124, 1121, 2, 501, 124, 1,
      1, 1, 20696, 32, 92, 1, 1, 1, 29, 1, 1, 1, 56, 32, 92, 1, 1, 1, 29, 1, 1,
      1, 56, 32, 92, 1, 1, 1, 29, 1, 1, 1, 56, 32, 92, 1, 1, 1, 29, 1, 1, 1, 56,
      32, 92, 1, 1, 1, 29, 1, 1, 1, 56, 32, 92, 1, 1, 1, 29, 1, 1, 1, 2637, 1,
      2, 124, 88, 1, 2, 124, 88, 1, 2, 124, 88, 1, 2, 124, 88, 1, 2, 124, 303,
      1, 2, 124, 46, 2, 213, 2, 213, 2, 213, 2,
    ],
    -45,
    [
      54, 2637, 4451, 2, 121, 1, 1, 1, 1, 2, 2063, 32, 92, 2199, 123, 1, 1, 1,
      1, 2, 20941, 2, 121, 1, 1, 1, 1, 2, 86, 2, 121, 1, 1, 1, 1, 2, 86, 2, 121,
      1, 1, 1, 1, 2, 86, 2, 121, 1, 1, 1, 1, 2, 86, 2, 121, 1, 1, 1, 1, 2, 86,
      2, 121, 1, 1, 1, 1, 2,
    ],
    -40,
    [
      7794, 1, 2, 124, 2217, 19, 4, 96, 1, 1, 1, 1, 1, 540, 3402, 2652, 19727,
      19, 4, 96, 1, 1, 1, 1, 1, 91, 19, 4, 96, 1, 1, 1, 1, 1, 91, 19, 4, 96, 1,
      1, 1, 1, 1, 91, 19, 4, 96, 1, 1, 1, 1, 1, 91, 19, 4, 96, 1, 1, 1, 1, 1,
      306, 19, 4, 96, 1, 1, 1, 1, 1, 5304,
    ],
    -37,
    [11683, 123, 1, 1, 1, 29, 490, 124, 5191, 5875, 34, 15436, 124],
    -35,
    [
      7773, 119, 1, 1, 1, 1, 1, 2908, 2, 124, 1371, 123, 1, 1, 1, 1, 2, 26531,
      123, 1, 1, 1, 1, 2,
    ],
    -34,
    [11269, 32, 92],
    -30,
    [
      52, 3, 7288, 119, 1, 1, 1, 1, 1, 1596, 119, 1, 1, 1, 1, 1, 105, 123, 1, 1,
      1, 1, 2, 1376, 6, 117, 1, 1, 1, 1, 2, 1, 1, 1, 1, 719,
    ],
    -25,
    [
      7175, 1060, 4, 10, 105, 1, 1, 1, 1, 1, 3, 1, 1, 1, 7, 1, 1, 1, 1, 2, 936,
      10, 113, 1, 1, 1, 7, 1, 1, 1, 1, 2, 4608, 1062, 6, 123, 1, 1, 1, 1, 2,
      3956, 123, 1, 1, 1, 1, 2, 6751, 123, 1, 1, 1, 1, 2, 6537, 215, 215, 215,
      215, 215, 5811, 215, 215, 215, 215, 215, 5153, 123, 1, 1, 1, 1, 2,
    ],
    -20,
    [
      7754, 1290, 527, 352, 119, 1, 1, 1, 1, 1, 342, 10, 113, 1, 1, 1, 7, 1, 1,
      1, 1, 2, 21, 3726, 124, 1, 1, 1, 9101, 14, 4, 12847, 119, 1, 1, 1, 1, 1,
    ],
    -18,
    [
      11227, 26, 97, 1, 1, 1, 1, 2, 21, 521, 124, 5675, 2, 10, 2, 110, 1, 1, 1,
      1, 7, 1, 1, 1, 1, 2,
    ],
    -15,
    [
      9095, 4, 10, 6, 99, 1, 1, 1, 1, 1, 3, 1, 1, 1, 7, 1, 1, 1, 1, 2, 1, 1, 1,
      1, 88, 124, 1, 1, 1, 4819, 431, 214, 141, 2, 215, 290, 32, 92, 511, 10,
      32, 81, 1, 1, 1, 1, 2, 5, 1370, 123, 23535, 215, 215, 215,
    ],
    -10,
    [
      7363, 124, 1, 1, 1, 2895, 119, 1, 1, 1, 1, 1, 79, 124, 1, 1, 1, 1157, 123,
      1, 1, 1, 1, 2, 2255, 1525, 413, 123, 1, 1, 1, 751, 1, 629, 9, 6, 839, 4,
      10, 105, 1, 1, 1, 1, 1, 3, 1, 1, 1, 7, 1, 1, 1, 1, 2, 86, 123, 1, 1, 1, 1,
      2, 291, 123, 1, 1, 1, 3923, 119, 1, 1, 1, 1, 1, 306, 119, 1, 1, 1, 1, 1,
      2277, 123, 1, 1, 1, 16016, 215, 215, 215, 645, 1, 214, 1, 214, 1, 214, 1,
      214, 1, 429, 1, 1057, 123, 1, 1, 1,
    ],
    50,
    [15161],
    55,
    [15159],
  ],
};
